<template>
  <Teleport
    :to="teleportTo"
    :disabled="!teleport"
  >
    <div class="loader p-fixed">
      <div
        data-grid
        class="loader__wrapper grid--va-center grid--center w-100 h-100"
      >
        <slot name="loading">
          <GlobalLoading />
        </slot>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { defineComponent } from 'vue'

import GlobalLoading from './GlobalLoading.vue'

export default defineComponent({
  name: 'Loader',

  components: {
    GlobalLoading
  },

  props: {
    teleport: Boolean,

    teleportTo: {
      type: String,
      default: () => 'body'
    }
  }
})
</script>

<style lang="scss" scoped>
  .loader {
    inset: 0;
    z-index: 9999;
    width: 100vw;
    height: 100%;
    transition: all .4s ease-in-out;
    background-color: rgba(var(--black1), .4);
  }
</style>
